export * from './window-type-1.component';